import { UserSessionsForDebugApi } from "../../generated"
import { apiConfig } from "../apiConfig"
import { useCallback, useState } from "react"
import { DebugSignInRequest } from "./DebugSignInRequest"

const api = new UserSessionsForDebugApi(apiConfig)

export function useDebugAdminSighnIn() {
  const [loginError, setLoginError] = useState<boolean>(false)
  const signIn = useCallback((data: DebugSignInRequest) => {
    api.adminSignIn(data.key)
      .then(_ => {

        console.debug('success. you are now login.')

        setLoginError(false)
        location.reload()
      }).catch(err => {
        setLoginError(true)
        console.error('エラーが発生しました。対応未実装')
        console.error(err)

      })
  }, [])
  return { loginError, signIn }
}
